import appSettings from "apps/services/config";
import { EntityRepository, getManager, Repository } from "typeorm";

import { ProductConversion } from "../product-conversion.entity";

const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const productionLogTable = appSettings.production_db + '.production_log';
const productionInvTable = appSettings.production_db + '.production_inventory';
const workStationTable = appSettings.production_db + '.workstations';
@EntityRepository(ProductConversion)
export class ProductConversionRepository extends Repository<ProductConversion> {
}